import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-participant-speaks',
  templateUrl: './participant-speaks.component.html',
  styleUrls: ['./participant-speaks.component.scss']
})
export class ParticipantSpeaksComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
